import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver_profiles_commonCaregiverProfile_qualities as Qualities } from '@/__generated__/getSearchResults';
import { shuffleWithSeed } from './shuffleWithSeed';

// These are the only skills we want to show on the robust caregiver card
const CAREGIVER_SKILLS: Record<string, string> = {
  cprTrained: 'CPR',
  earlyChildhoodEducation: 'Early Education',
  firstAidTraining: 'First Aid',
  specialNeedsCare: 'Special Needs Care',
  trustlineCertifiedCalifornia: 'Trustline Certified',
  certifiedNursingAssistant: 'CNA',
  alzheimersOrDementiaExperience: 'Alzheimers or Dementia Experience',
  homeHealthAideExperience: 'Home Health Aide',
  licensedNurse: 'Licensed Nurse',
  medicalEquipmentExperience: 'Medical Equipment Experience',
  woundCare: 'Wound Care',
  isBondedAndInsured: 'Bonded and insured',
  isNappsCertified: 'NAPPS Certified',
  isPSAMemberAndisInsured: 'PSA member and insured',
  isRedCrossPetFirstAidCertified: 'Red Cross Pet First Aid Certified',
};

const convertSkillsToStrings = (qualities: Qualities): string[] => {
  return Object.entries(qualities)
    .filter(([skill, value]) => value === true && CAREGIVER_SKILLS[skill])
    .map(([key]) => CAREGIVER_SKILLS[key]);
};

const shuffleCaregiverSkills = (qualities: Qualities | null, seed: number): string[] => {
  if (!qualities) return [];

  const mapQualities = convertSkillsToStrings(qualities);

  // return 0 - 2 caregiver services.
  return shuffleWithSeed(mapQualities.slice(0, 3), seed);
};

export default shuffleCaregiverSkills;
